<template>
  <el-dialog title="消息通知设置" :visible.sync="visible" width="552px" :append-to-body="true" center>
    <div class="fix-form">
      <!-- {{ checkList }}{{ notificationSettings }} -->
      <div class="label-title">1.当审批单被拒绝时，通知以下节点人员:</div>
      <el-checkbox-group v-model="checkList"  class="check-group">
        <el-checkbox label="onRejectionNotifyAllBeforeRejection"><span class="name-text">拒绝节点前的所有人</span></el-checkbox>
        <el-checkbox label="onRejectionNotifyOtherOrSignApprovers"><span class="name-text">或签节点的其他或签审批人</span></el-checkbox>
        <el-checkbox label="onRejectionNotifyOtherAndSignApprovers"><span class="name-text">会签节点的其他会签审批人</span></el-checkbox>
      </el-checkbox-group>
      <div class="label-title">2.当审批单被同意时，通知以下节点人员:</div>
      <el-checkbox-group v-model="checkList" class="check-group">
        <el-checkbox label="onApprovalNotifyOtherOrSignApprovers"><span class="name-text">或签节点的其他或签审批人</span></el-checkbox>
      </el-checkbox-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
let checkKey = ['onRejectionNotifyAllBeforeRejection','onRejectionNotifyOtherOrSignApprovers','onRejectionNotifyOtherAndSignApprovers','onApprovalNotifyOtherOrSignApprovers']
export default {
  name: "messageSetting",
  components: {},
  data() {
    return {
      visible: false,
      checkList:[],
      notificationSettings: {...this.$store.state.design.settings.notificationSettings}
    }
  },
  created() {
    
    
  },
  methods: {
    show() {
      this.visible = true
      this.notificationSettings = this.$deepCopy(this.$store.state.design.settings.notificationSettings)
      this.checkList = this.getTrueKeys(this.notificationSettings)
    },
    save() {
      checkKey.forEach(key=>{
        let value = this.checkList.includes(key)
        let data ={
          key:key,
          value
          }
          this.$store.commit("updateProNotice",data);
      })
      this.visible = false
    },
    getTrueKeys(obj) {
      return Object.entries(obj).filter(([key, value]) => key !== 'enable' && value === true).map(([key]) => key);
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog--center .el-dialog__body{
  padding: 10px 32px 0;
}
.fix-form{
  .label-title{
    font-weight: bold;
    font-size: 14px;
    color: #2F3030;
    margin-bottom: 2px;
  }
  /deep/.check-group{
    margin-bottom: 20px;
  }
  /deep/.el-checkbox{
    display: block;
    line-height: 34px;
    .name-text{
      color: #606266;
    }
  }
}
</style>
